
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoPurOrderDtGrid extends Serenity.EntityGrid<PoPurOrderDtRow, any> {
        protected getColumnsKey() { return PoPurOrderDtColumns.columnsKey; }
        protected getDialogType() { return PoPurOrderDtDialog; }
        protected getIdProperty() { return PoPurOrderDtRow.idProperty; }
        protected getInsertPermission() { return PoPurOrderDtRow.insertPermission; }
        protected getLocalTextPrefix() { return PoPurOrderDtRow.localTextPrefix; }
        protected getService() { return PoPurOrderDtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}